export const GOOGLE_BASE_SCOPES = ['https://www.googleapis.com/auth/userinfo.profile', 'https://www.googleapis.com/auth/userinfo.email'];
export const GOOGLE_CALENDAR_SCOPES = [
    // 'https://www.googleapis.com/auth/calendar.events',
    // 'https://www.googleapis.com/auth/calendar.app.created',
    'https://www.googleapis.com/auth/calendar',
    ...GOOGLE_BASE_SCOPES,];
export const GMAIL_SCOPES = ['https://www.googleapis.com/auth/gmail.send', ...GOOGLE_BASE_SCOPES];